// extracted by mini-css-extract-plugin
export var completionBody = "_cm-2";
export var completionCard = "_cm-0";
export var completionFooter = "_cm-3";
export var completionTitle = "_cm-1";